<!-- 基础产品模糊搜索 -->
<template>
    <div class='seach'>
        <el-autocomplete  v-model="data.productNameCn" size="small" :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容" @select="handleSelect">
            <template slot-scope="{ item }">
                <div class="name">{{ item.productNameCn }} <span v-if="item.productNameEn">({{ item.productNameEn }})</span></div>
            </template>
        </el-autocomplete>
    </div>
</template>

<script>
import Api from '../../../../../components/Api'
export default {
    components: {},
    props: {
        data: {
            type: Object,
            default: () => { }
        },
        state: {
            type: Number,
        },
        keys: {
            type: String,
            default: ''
        },
        rid:{

        },
        //是否过滤
        isFilter:{
            type:Boolean,
            default:false
        },
        //过滤的名字
        filterName:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            input1: '',
            molds: {
                '0': 10,
                '4': 64,
                '3': 133,
                '5': 75,
                '7': 410
            },
        }
    },
    computed: { },
    watch: {},
    methods: {
        querySearchAsync(queryString, cb) {
            let obj = {
                "page": 1,
                "q": {
                    "state": this.state,
                    "rid": this.rid,
                },
                "size": 20
            }
            new Api('resource').resourceProductList(obj).then(res => {
                if (res.status == 200) {
                    if(this.isFilter) {
                        res.data.records = res.data.records.filter(n => n.productNameCn != this.filterName)
                    }
                    cb(res.data.records)
                }
            })
        },
        handleSelect(item) {
            this.$set(this.data,'productNameCn',item.productNameCn ? item.productNameCn : item.productNameEn)
            this.$set(this.data,'cityName',item.cityName)
            this.$set(this.data,'nameCn',item.nameCn)
            this.$set(this.data,'state',item.state)
            this.$set(this.data,'rid',item.rid)
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>